import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ValidationlogRoutingModule } from './validationlog-routing.module';
import { ValidationlogComponent } from './validationlog.component';
import { FormsModule } from '@angular/forms';
import { DxChartModule, DxDropDownButtonModule, DxToolbarModule, DxScrollViewModule, DxPopupModule, DxPopoverModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { SharedModule } from 'src/app/pipes/shared-module';
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';
import { WebExportModule } from 'src/app/widgets/web-export/web.export.module';
import { ContainerComponent } from 'src/app/components/container/container.component';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { FiltersGroupModule } from 'src/app/widgets/filters/filters-group/filters-group.module';
import { HelpButtonComponent } from 'src/app/widgets/help-button/help-button.component';


@NgModule({
  declarations: [ValidationlogComponent],
  imports: [
    CommonModule,
    DevEpressCommonModule,
    DxChartModule,
    DxDropDownButtonModule,
    DxToolbarModule,
    SharedModule, FormsModule, DxScrollViewModule,
    ValidationlogRoutingModule, BookmarkModule, DxPopupModule,
    DxPopoverModule, WebExportModule,FiltersGroupModule,HelpButtonComponent,BookmarkNewComponent,
	ContainerComponent,
  ]
})
export class ValidationlogModule { }
